import React from "react";
import AssignmentSettingsPanel from "./AssignmentSettingsPanel";

const AssignmentSettingsPage = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-[#002966]">
          Auto-Assignment Settings
        </h1>
        <p className="text-gray-600 mt-1">
          Configure the automatic ticket and chat assignment system
        </p>
      </div>
      <AssignmentSettingsPanel />
    </div>
  );
};

export default AssignmentSettingsPage;
